import React, { useState, useEffect } from 'react';
import { collection, query, orderBy, getDocs, doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebaseconfig';
import Header from './Header';
import PostList from './PostList';
import PostModal from './PostModal';
import { fetchUsers } from '../../utils/userUtils';
import SubareaBudgetVisualization from './SubareaBudgetVisualization';
import { fetchPosts, addOrUpdatePost, deletePost } from '../../utils/postUtils';
import '../../css/AreaPage.css';

const updateUsedArea = async (area, posts) => {
  const totalInvestment = posts.reduce((sum, post) => sum + (parseFloat(post.costo) || 0), 0);

  const areaDocRef = doc(db, 'budgets', area);
  await updateDoc(areaDocRef, {
    usedarea: totalInvestment,
    used: totalInvestment
  });
};

const AreaPage = ({ username, userArea, onLogout, onChangePassword, setIsChangePasswordModalOpen, darkMode, toggleDarkMode }) => {
  const [posts, setPosts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editPostId, setEditPostId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('fecha');
  const [sortOrder, setSortOrder] = useState('desc');
  const [users, setUsers] = useState({});

  useEffect(() => {
    fetchUsers().then(setUsers);
  }, []);

  useEffect(() => {
    const loadPosts = async () => {
      const postsData = await fetchPosts(userArea, sortBy, sortOrder);
      setPosts(postsData);
      await updateUsedArea(userArea, postsData);
    };
    loadPosts();
  }, [sortBy, sortOrder, userArea]);

  const handleSubmit = async (formData) => {
    const updatedPost = await addOrUpdatePost(userArea, formData, editPostId);
    setPosts(prevPosts => {
      let newPosts;
      if (editPostId) {
        newPosts = prevPosts.map((post) => post.id === editPostId ? updatedPost : post);
      } else {
        newPosts = [...prevPosts, updatedPost];
      }
      updateUsedArea(userArea, newPosts);
      return newPosts;
    });
    setShowModal(false);
    setEditPostId(null);
  };

  const handleEdit = (postId) => {
    setEditPostId(postId);
    setShowModal(true);
  };

  const handleDelete = async (postId) => {
    await deletePost(userArea, postId);
    setPosts(prevPosts => {
      const newPosts = prevPosts.filter((post) => post.id !== postId);
      updateUsedArea(userArea, newPosts);
      return newPosts;
    });
  };

  return (
    <div className={`container-nav ${darkMode ? 'dark-mode' : ''}`}>
      <Header 
        userArea={userArea} 
        onAddPost={() => {
          setEditPostId(null);
          setShowModal(true);
        }} 
        onLogout={onLogout} 
        darkMode={darkMode} 
        toggleDarkMode={toggleDarkMode} 
        setIsChangePasswordModalOpen={setIsChangePasswordModalOpen}
      />
      <main>
        <PostList 
          posts={posts}
          users={users}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          sortBy={sortBy}
          sortOrder={sortOrder}
          setSortBy={setSortBy}
          setSortOrder={setSortOrder}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      </main>
      <SubareaBudgetVisualization userArea={userArea} />
      {showModal && (
        <PostModal
          onSubmit={handleSubmit}
          onClose={() => { 
            setShowModal(false); 
            setEditPostId(null); 
          }}
          initialData={editPostId ? posts.find(post => post.id === editPostId) : null}
          username={username}
          userArea={userArea}
        />
      )}
    </div>
  );
};

export default AreaPage;